import {
  NEW_COLLECTION_OVERVIEW,
  NEW_CUSTOMER_OVERDUE,
  NEW_INVOICE_SUMARY,
  NEW_SALES_REPORT

} from '../actions/reportsActions';


const initialState = {
  collectionOverview: null,
  customerOverdue: null,
  invoiceSumary: null,
  sales: null

} // END initialState


export default function (state = initialState, action) {
  let { payload, type } = action, newState;
  switch (type) {
    // Settings
    case NEW_COLLECTION_OVERVIEW:
      newState = { collectionOverview: payload }
      return { ...state, ...newState }

    case NEW_CUSTOMER_OVERDUE:
      newState = { customerOverdue: payload }
      return { ...state, ...newState }

    case NEW_INVOICE_SUMARY:
      newState = { invoiceSumary: payload }
      return { ...state, ...newState }

    case NEW_SALES_REPORT:
      newState = { sales: payload }
      return { ...state, ...newState }

    default:
      return state;

  } // END switch

} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/reportsReducer.js